
import React, { memo, useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleDown, faChevronCircleUp } from '@fortawesome/free-solid-svg-icons';

import NoEnrollmentMessage from './NoEnrollmentsMessage';
import EnrollmentContainer from './EnrollmentContainer';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import { IEnrollmentDetails } from './enrollmentHistoryTypes';
import { LOGO_URLS } from '../hooks/useEnrollmentHistory';

const StyledContainer = styled.div`
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    min-height: 20px;
    border-radius: 0;
    margin-right: 0px !important;
    box-shadow: none;
`;

const StyledTitleDiv = styled.div`
    img{
        width: 30px;
        margin:7px 7px 7px 20px
    }
`;

interface ICurrentEnrollments {
    activeHealthEnrollments: IEnrollmentDetails[],
    activeDentalEnrollments: IEnrollmentDetails[],
    coverageStartDateForDisenrollment: string,
    coverageYear: string
}

const CurrentEnrollmentContainer = (props: ICurrentEnrollments) => {
    const { activeHealthEnrollments, activeDentalEnrollments, coverageStartDateForDisenrollment, coverageYear } = { ...props };
    const [isShowActiveHealth, setIsShowActiveHealth] = useState(true);
    const [isShowActiveDental, setIsShowActiveDental] = useState(true);
    const hasActiveHealthEnrollments = activeHealthEnrollments.length > 0;
    const hasActiveDentalEnrollments = activeDentalEnrollments.length > 0;
    const hasNoEnrollments = activeHealthEnrollments.length === 0 && activeDentalEnrollments.length === 0;

    return (
        <>
            <ConditionalRendering isTrue={hasActiveHealthEnrollments}>
                <div id="myHealthPlan">
                    <div className='activeEnrollment' data-testid="activeEnrollment">
                        <StyledContainer>
                            <StyledTitleDiv className='collapse-header'>
                                <div data-testid="activeEnrollment-health">
                                    <img src={LOGO_URLS.HEALTH} alt="Medical Plan Image"></img>
                                    &nbsp;<FormattedMessage id="indportal.enrollments.healthPlan" />
                                </div>
                                <FontAwesomeIcon data-testid='active-health-toggle' icon={isShowActiveHealth ? faChevronCircleUp : faChevronCircleDown} className='margin-t-10 margin-r-10'
                                    onClick={() => setIsShowActiveHealth(!isShowActiveHealth)} />
                            </StyledTitleDiv>
                            <ConditionalRendering isTrue={isShowActiveHealth}>
                                <div className='enrollment-container'>
                                    <EnrollmentContainer enrollments={activeHealthEnrollments} activeEnrollment='true' coverageStartDateForDisenrollment={coverageStartDateForDisenrollment} coverageYear={coverageYear} />
                                </div>
                            </ConditionalRendering>
                        </StyledContainer>
                    </div>
                </div>
            </ConditionalRendering>
            <ConditionalRendering isTrue={hasActiveDentalEnrollments}>
                <div id="myDentalPlan">
                    <div className='activeEnrollment'>
                        <StyledContainer>
                            <StyledTitleDiv className='collapse-header'>
                                <div data-testid="activeEnrollment-dental">
                                    <img src={LOGO_URLS.DENTAL} alt="Medical Plan Image"></img>
                                    &nbsp;<FormattedMessage id="indportal.enrollments.dentalPlan" />
                                </div>
                                <FontAwesomeIcon data-testid='active-dental-toggle' icon={isShowActiveDental ? faChevronCircleUp : faChevronCircleDown} className='margin-t-10 margin-r-10'
                                    onClick={() => setIsShowActiveDental(!isShowActiveDental)} />
                            </StyledTitleDiv>
                            <ConditionalRendering isTrue={isShowActiveDental}>
                                <div className='enrollment-container'>
                                    <EnrollmentContainer enrollments={activeDentalEnrollments} activeEnrollment='true' coverageStartDateForDisenrollment={coverageStartDateForDisenrollment} coverageYear={coverageYear} />
                                </div>
                            </ConditionalRendering>
                        </StyledContainer>
                    </div>
                </div>
            </ConditionalRendering>
            <ConditionalRendering isTrue={hasNoEnrollments}>
                <NoEnrollmentMessage />
            </ConditionalRendering>
        </>
    );
};

export default memo(CurrentEnrollmentContainer);